import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class GetAlbumListAPICall extends APICallV4 {
    _method = 'album/list';
    _type: Method = 'get';
    _retriesCount = 0;
}
